import { Box, Button, CircularProgress, Typography } from "@mui/material";

const formatAmount = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return "—";
  return num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default function OrderSummary({
  lineCount,
  estimatedSubtotal,
  onSubmit,
  submitting,
  disabled,
}) {
  return (
    <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid #eee" }}>
      <Typography variant="body2" color="text.secondary">
        {lineCount} unit{lineCount === 1 ? "" : "s"} selected
      </Typography>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mt: 0.5 }}>
        Estimated subtotal: {formatAmount(estimatedSubtotal)}
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        sx={{ mt: 0.5 }}
      >
        Estimates use catalog cost (same as mobile). Final pricing is calculated
        on the server.
      </Typography>
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2, bgcolor: "#e90000", "&:hover": { bgcolor: "#c00000" } }}
        onClick={onSubmit}
        disabled={disabled || submitting || lineCount < 1}
      >
        {submitting ? (
          <CircularProgress size={22} color="inherit" />
        ) : (
          "Create order"
        )}
      </Button>
    </Box>
  );
}
